/**
 * Global XHR interceptor plugin
 * Installs BEFORE any other scripts load to catch all XHR requests
 */
export default defineNuxtPlugin(() => {
	// Store the original XMLHttpRequest
	const originalXHR = window.XMLHttpRequest;

	if (process.env.NODE_ENV === "development") {
		 
		console.log("🔧 Global XHR interceptor installed");
	}

	// Create a global state for validation
	const validationState = useState("validation", () => ({
		isValidating: false,
		showSuccessMessage: false,
		showErrorMessage: false,
		errorDetails: {}
	}));

	// Override XMLHttpRequest globally
	window.XMLHttpRequest = function () {
		 
		const xhr = new originalXHR();
		const originalOpen = xhr.open;
		const originalSend = xhr.send;
		let requestUrl = "";

		// Override open to capture the URL
		xhr.open = function (method, url, ...args) {
			requestUrl = url;
			return originalOpen.apply(this, [method, url, ...args]);
		};

		// Override send to capture the response
		xhr.send = function (...args) {
			// Check if this is a validation request
			if (requestUrl.includes("/validator/validate")) {
				if (process.env.NODE_ENV === "development") {
					 
					console.log(
						"🎯 XHR Interceptor: Validation request detected!",
						requestUrl
					);
				}
				validationState.value.isValidating = true;

				// Listen for the response
				xhr.addEventListener("load", function () {
					validationState.value.isValidating = false;

					if (xhr.status >= 200 && xhr.status < 300) {
						try {
							const response = JSON.parse(xhr.responseText);
							if (process.env.NODE_ENV === "development") {
								 
								console.log("✅ XHR Interceptor: Validation response:", response);
							}

							// Check validation results
							const emailValid = !response.email || response.email === "valid";
							const phoneValid = !response.phone || response.phone === "valid";

							if (emailValid && phoneValid) {
								validationState.value.showSuccessMessage = true;
								validationState.value.showErrorMessage = false;

								// Set flag for post-redirect success message
								if (typeof window !== "undefined" && window.localStorage) {
									window.localStorage.setItem("stt_submission_success", "true");
								}

								setTimeout(() => {
									validationState.value.showSuccessMessage = false;
								}, 5000);
							} else {
								validationState.value.showErrorMessage = true;
								validationState.value.showSuccessMessage = false;
								validationState.value.errorDetails = response;
								setTimeout(() => {
									validationState.value.showErrorMessage = false;
								}, 10000); // 10 seconds - doubled from 5 seconds
							}
						} catch (error) {
							if (process.env.NODE_ENV === "development") {
								 
								console.error("Error parsing validation response:", error);
							}
						}
					} else {
						validationState.value.isValidating = false;
						validationState.value.showErrorMessage = true;
						validationState.value.showSuccessMessage = false;
						validationState.value.errorDetails = {
							message: `Request failed with status ${xhr.status}`
						};
						setTimeout(() => {
							validationState.value.showErrorMessage = false;
						}, 10000); // 10 seconds
					}
				});

				xhr.addEventListener("error", function () {
					validationState.value.isValidating = false;
					validationState.value.showErrorMessage = true;
					validationState.value.showSuccessMessage = false;
					validationState.value.errorDetails = {
						message: "Network error occurred during validation"
					};
					setTimeout(() => {
						validationState.value.showErrorMessage = false;
					}, 10000); // 10 seconds
				});
			}

			return originalSend.apply(this, args);
		};

		return xhr;
	};

	// Provide a helper to access validation state
	return {
		provide: {
			validationState: () => validationState.value
		}
	};
});
